// This function allow to reference async chunks
__webpack_require__.k = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + "6e6bd8c1" + ".css";
};